// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"125":"0f0f00b3d15e7ffce003","293":"7382ef2670c1ed773908","385":"19bc429460bb204d20dc"}[chunkId] + ".js";
};